import { render } from "./FacetPanel.vue?vue&type=template&id=2b5b9011&scoped=true&ts=true"
import script from "./FacetPanel.vue?vue&type=script&lang=ts"
export * from "./FacetPanel.vue?vue&type=script&lang=ts"

import "./FacetPanel.vue?vue&type=style&index=0&id=2b5b9011&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1128706856/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5b9011"]])

export default __exports__